import './index.scss'

interface BackToTopProps {
  visible: boolean
  onClick: () => void
}

/** 返回顶部浮动按钮 — 根据 visible prop 控制显隐 */
export default function BackToTop({ visible, onClick }: BackToTopProps) {
  return (
    <div className="back-to-top" style={{ display: visible ? 'flex' : 'none' }} onClick={onClick} title="返回顶部">
      ↑
    </div>
  )
}
